<!-- title -->
<app-modal-title
  [title]="'common.SelectedPhonebooks' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div
  mat-dialog-content
  class="dialog-content tw-max-h-[450px] tw-overflow-y-scroll"
>
  <table
    class="table table-striped-even table-head-custom table-vertical-center"
  >
    <thead>
      <tr class="fw-bold fs-6 tw-text-gray-800">
        <th
          class="tw-text-center !tw-text-primary-500 dark:tw-text-primary-400"
        >
          {{ "common.row" | translate }}
        </th>
        <th
          class="tw-text-center !tw-text-primary-500 dark:tw-text-primary-400"
        >
          {{ "common.name" | translate }}
        </th>
        <th
          class="tw-text-center !tw-text-primary-500 dark:tw-text-primary-400"
        >
          {{ "common.contactsCount" | translate }}
        </th>
        <th
          class="tw-text-center !tw-text-primary-500 dark:tw-text-primary-400"
        >
          {{ "common.fromIndex" | translate }}
        </th>
        <th
          class="tw-text-center !tw-text-primary-500 dark:tw-text-primary-400"
        >
          {{ "common.count" | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let item of recipients | removeEmptyContacts; let index = index"
        [class.text-danger]="!item.isValid"
      >
        <td class="tw-text-center">
          <span class="tw-opacity-50"> {{ index + 1 }}</span>
        </td>
        <td class="tw-text-center">{{ item.name }}</td>
        <td class="tw-text-center">
          {{ item.contactsCount | numberSeparator }}
        </td>
        <td class="tw-text-center">
          <span class="tw-font-medium">{{
            item.fromIndex | numberSeparator
          }}</span>
        </td>
        <td class="tw-text-center">
          <span class="tw-font-medium">{{ item.count | numberSeparator }}</span>
        </td>
      </tr>

      <tr *ngIf="recipients.length > 0">
        <td
          class="tw-text-center !tw-py-3 tw-text-gray-600 sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
          colspan="4"
        >
          {{ "common.totalRecipients" | translate }}
        </td>
        <td
          class="tw-text-center tw-text-gray-800 tw-font-medium sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        >
          <span class="max-td-value">
            {{ totalRecipients || "-" | numberSeparator }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
